module.exports = __webpack_public_path__ + "static/img/img_gaojia.d6c5cc4d.png";